import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ProjectsPage } from '@/features/projects/projects-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/projects/')({ component: ProjectsRoute });

function ProjectsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="projects" crumbs={[{ label: t('nav.items.projects') }]}>
      <ProjectsPage tenantId={tenant} />
    </ConsoleShell>
  );
}
